import {
  Store as VuexStore,
  ActionTree,
  ActionContext,
  GetterTree,
  Module,
  MutationTree,
  CommitOptions,
  DispatchOptions,
} from "vuex";
import { DialogStep, DialogsState } from "@/store/modules/dialogs/dialogs-state";
import { RootState } from "@/store/root-state";

const namespaced = false;

// initial state
const state: DialogsState = {
  dialogSteps: {},
};

export type Getters = {
  getDialogStep: (state: DialogsState) => (name: string) => DialogStep;
};

const getters: GetterTree<DialogsState, RootState> = {
  getDialogStep:
    (state: DialogsState) =>
    (name: string): DialogStep => {
      return state.dialogSteps[name];
    },
};

export type Mutations = {
  setForm(state: DialogsState, payload: { name: string; form: any }): void;
  setData(state: DialogsState, payload: { name: string; data: any }): void;
  clearSteps(state: DialogsState): void;
};

const mutations: MutationTree<DialogsState> & Mutations = {
  setForm(state: DialogsState, payload: { name: string; form: any }): void {
    !state.dialogSteps[payload.name] && (state.dialogSteps[payload.name] = new DialogStep());
    state.dialogSteps[payload.name].form = payload.form;
  },
  setData(state: DialogsState, payload: { name: string; data: any }): void {
    !state.dialogSteps[payload.name] && (state.dialogSteps[payload.name] = new DialogStep());
    state.dialogSteps[payload.name].data = payload.data;
  },
  clearSteps(state: DialogsState): void {
    state.dialogSteps = {};
  },
};

// actions
// export interface Actions {}

const actions: ActionTree<DialogsState, RootState> = {};

export const dialogs: Module<DialogsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};

export type DialogsStore<S = DialogsState> = Omit<VuexStore<S>, "getters" | "commit" | "dispatch"> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  getters: {
    [K in keyof Getters]: ReturnType<Getters[K]>;
  };
};
